import * as React from 'react';

import { Icon } from '@/shared/types/icon';

const AgoraVoice = ({ size = 24, ref, ...props }: Icon & { ref?: React.Ref<SVGSVGElement> }) => {
  return (
    <svg
      {...props}
      ref={ref}
      width={size}
      height={size}
      viewBox="75 80 240 240"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#00C2FF"
        fillRule="evenodd"
        d="M195 93a107 107 0 0 1 65.07 22.06A111 111 0 0 1 302 93v214a111 111 0 0 1-41.93-22.06A107 107 0 1 1 195 93Zm0 48a59 59 0 1 0 0 118 59 59 0 0 0 0-118Z"
      />
    </svg>
  );
};

export default AgoraVoice;
